export const domainToTenantMap = {
  "cata-dev.ooloilabs.in": "cata",

  "cata-staging.ooloilabs.in": "cata",

  "makingitrealfp.org": "cata", //
};

export const getTenant = () => {
  if (
    process.env.NODE_ENV === "production" &&
    !window.location.origin.includes(
      "-dot-okf-fe-dev-dot-ok-framework.el.r.appspot.com"
    )
    // && import.meta.env.VITE_ENV !== 'dev' //activate when we wanna make dev a single url
  ) {
    return domainToTenantMap[window.location.hostname];
  } else {
    //locahost
    return (
      localStorage.getItem("localhost_tenantId") ||
      Object.values(domainToTenantMap)[0]
    );
  }
};
